<template>
    <div>
        <el-input
            v-model="input"
            class="com-input"
            :class="{ 'is-error': isError }"
            :value="value"
            v-bind="props"
            @keyup.enter.native="inputHandler"
        />
        <el-button type="primary" @click="inputHandler">{{ widget.props.searchText }}</el-button>
    </div>
</template>

<script>
import Validation from "../validation.js";
import { stringRequired, checkRule } from "@/views/zhiji/components/commonForm/rules.js";

export default {
    name: "CompoundInput",
    props: ["value", "widget", "rules", "validation"],
    model: {
        prop: "value",
        event: "change"
    },
    data() {
        return {
            isValid: true,
            message: "",
            myValidation: null,
            input: this.value || "",
        };
    },
    computed: {
        props() {
            return this.widget.props;
        },
        isError() {
            return !this.isValid;
        }
    },
    created() {
        this.myValidation = new Validation({
            tiggerHanlder: () => this.validate(this.value),
            propName: this.widget.name
        });
        this.validation && this.validation.hasOwnProperty("addChild") && this.validation.addChild(this.myValidation);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    methods: {
        inputHandler() {
            // 为textarea时需要输入空格进行换行，不做trim处理
            const needTrim = this.props.needTrim !== null ? this.props.needTrim : this.widget.props.type && this.widget.props.type === "textarea";
            const tirmValue = needTrim ? this.input.trim() : this.input;
            this.$emit("change", tirmValue);
            this.verifyHandler(tirmValue);
        },
        verifyHandler(newValue) {
            this.validate(newValue);
            this.emitValid();
        },
        validate(newValue) {
            const rules = (this.rules || []).map(rule => {
                if (rule.required) {
                    return { validator: stringRequired, message: rule.message || "请输入必要内容" };
                }
                return rule;
            });
            if (rules.length === 0) {
                return;
            }
            const result = checkRule(newValue, rules);
            this.isValid = result.isValid;
            this.message = result.message;
            this.$emit("verify", result);
            return result;
        },
        emitValid() {
            this.myValidation && this.myValidation.emit({ isValid: this.isValid, message: this.message });
        }
    }
};
</script>

<style scoped lang="less">
.com-input {
    margin-right: 8px;
}
.is-error {
    /deep/ input {
        border: 1px solid #f33535 !important;
    }
    /deep/ textarea {
        border: 1px solid #f33535 !important;
    }
}
</style>
